/**
 * K线图基类
 */
import {
  KLINE_MATYPE,
} from '../setting.js';
import BaseContext from '../basecontext';
import MainDectorator from '../dectorator/maindectorator';
import {checkMainAuth, checkMainTitleAuth} from '../../viewmodel/dectorator/checkauthdectorator/index.js';
import Util, {mergeModelData} from '../../util/index.js';
import {checkHKM, checkAmerican} from '../../controller/util.js';
const model = {
  maData: {
    Type: Object,
    Default: () => ({})
  },
  kline: {
    Type: Array,
    Default: () => ([])
  }
};
export default class KLineState extends MainDectorator(BaseContext) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    const {kline, start, end, sealObj} = this.state.data;
    const {ratioFixed} = sealObj;
    const klineData = kline.slice(start, end);
    const highList = klineData.map(a => a.high_px);
    const lowList = klineData.map(a => a.low_px);
    let maxValue = Math.max.apply(null, highList.length==0?[0]:highList);
    let minValue = Math.min.apply(null, lowList.length==0?[0]:lowList);
    // if (maxValue.toFixed(ratioFixed) == minValue.toFixed(ratioFixed)) {
    //   maxValue *= 1.01;
    //   minValue *= 0.99;
    // }
    this.maxValue = maxValue;
    this.minValue = minValue;
    this.baseValue = (maxValue + minValue) / 2;
  }
  _calcAxis() {
    const {kline, start, end} = this.state.data;
    const {
      height
    } = this.availArea;
    const minValue = this.minValue;
    const range = this.maxValue - this.minValue;
    const ratio = height / range;
    const len = Math.min(end, kline.length);
    for (let i = start; i < len; i++) {
      const kHeight = [];
      const kData = kline[i];
      ['high_px', 'open_px', 'close_px', 'low_px'].forEach(key => {
        kHeight.push({key, lineY: (kData[key] - minValue) * ratio});
      });
      kHeight.sort((a, b) => b.lineY - a.lineY);
      kData.kHeight = kHeight;
    }
  }
  _drawMain() {
    const {
      left,
      bottom
    } = this.availArea;
    const ctx = this.context;
    const {kline} = this.state.data;
    this._drawKline(kline, left, bottom);
  }
  _drawAxisY() {
    const {
      left,
      top,
      height,
      bottom
    } = this.availArea;
    const baseSize = this.state.baseSize;
    const {ratioFixed} = this.state.data.sealObj;

    // 纵坐标分为六段，每段的高、值
    const perHeight = height / 6;
    const nan = isNaN(this.maxValue - this.baseValue);
    const perValue = nan?0:(this.maxValue - this.baseValue)/3;
    // 画y轴坐标值
    const ctx = this.context;
    const {sizeRatio, fontFamily, color} = this.option.KLine.axisY;
    ctx.font = sizeRatio * baseSize * this.dpr + "px " + fontFamily;
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.fillStyle = color;
    // 最高线
    ctx.fillText(this.maxValue.toFixed(ratioFixed), left, top);
    // 第二条
    ctx.fillText((this.maxValue - perValue).toFixed(ratioFixed), left, top + perHeight);
    // 第三条
    ctx.fillText((this.maxValue - perValue * 2).toFixed(ratioFixed), left, top + perHeight * 2);
    // 中轴线
    ctx.fillText(this.baseValue.toFixed(ratioFixed), left, top + height / 2);
    // 第五条
    ctx.fillText((this.baseValue - perValue).toFixed(ratioFixed), left, top + perHeight * 4);
    // 第六条
    ctx.fillText((this.baseValue - perValue*2).toFixed(ratioFixed), left, top + perHeight * 5);
    // 最低线
    ctx.fillText(this.minValue.toFixed(ratioFixed), left, bottom);
  }
  _calcCursorAxis(index) {
    const {kline, start} = this.state.data;
    /*** 绘制Y轴标签 ***/
    const data = kline[index];
    if (data) {
      const close_px = data.kHeight.find(a => a.key === 'close_px');
      const high = data.kHeight.find(a => a.key === 'high_px').lineY;
      const low = data.kHeight.find(a => a.key === 'low_px').lineY;
      // const height=(high-low).toFixed(0)
      if (close_px) {
        const text = data.close_px;
        const y = close_px.lineY;
        return {text, y,high,low}
      }
    }
  }
  // @checkMainTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const {maData, current, sealObj, code, len} = this.state.data;
    const {height, top, baseSize} = this.state;
    const {ratioFixed} = sealObj;
    const {
      KLINE_MA5,
      KLINE_MA10,
      KLINE_MA20,
      KLINE_MA30,
      KLINE_MA60,
      KLINE_MA120
    } = KLINE_MATYPE;
    const {ma5, ma10, ma20, ma30, ma60, ma120, space, arrowWidth, arrowSpace} = this.option.MA;
    const {baseLine} = this.option.MainContext.title;
    const confList = {
      [KLINE_MA5]: ma5,
      [KLINE_MA10]: ma10,
      [KLINE_MA20]: ma20,
      [KLINE_MA30]: ma30,
      [KLINE_MA60]: ma60,
      [KLINE_MA120]: ma120,
    };
    const baseLineY = top + height * baseLine;
    const {colorMap} = this.option.BaseContext;
    let {left} = this.availArea;
    [
      KLINE_MA5,
      KLINE_MA10,
      KLINE_MA20,
      KLINE_MA30,
      KLINE_MA60,
      KLINE_MA120
    ].forEach((val, index) => {
      const {
        sizeRatio,
        fontFamily,
        color,
      } = confList[val];
      ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      ctx2.textAlign = 'left';
      ctx2.textBaseline = 'middle';
      const data = maData[val];
      const arrowY = baseLineY - sizeRatio * baseSize * this.dpr / 2;
      if (Util.isArray(data)) {
        ctx2.beginPath();
        const prevItem = data[current - 1] || data[len-2];
        const item = data[current] || data[len-1];
        if (Util.isDef(item) && Util.isValidNumber(item.close_px)) {
          // 大于100，显示整数部分
          const value = (item.close_px > 100 ? item.close_px.toFixed(0) : item.close_px.toFixed(ratioFixed));
          const text = (index === 0 ? 'MA' : 'MA') + val + ': ' + value;
          const textWidth = ctx2.measureText(text).width;
          ctx2.fillText(text, left, baseLineY);
          left += textWidth;
          // 箭头暂不做展示
          // if (Util.isDef(prevItem)) {
          //   const actWidth = arrowWidth * this.dpr;
          //   if (prevItem.close_px < item.close_px) {
          //     left += arrowSpace * this.dpr;
          //     this._drawUpArrow({x: left, y: arrowY, width: actWidth, height: sizeRatio * baseSize * this.dpr, color: colorMap[1]});
          //     left += actWidth;
          //   } else if (prevItem.close_px > item.close_px) {
          //     left += arrowSpace * this.dpr;
          //     this._drawDownArrow({x: left, y: arrowY, width: actWidth, height: sizeRatio * baseSize * this.dpr, color: colorMap[0]})
          //     left += actWidth;
          //   }
          // }
        } else {
          const text = (index === 0 ? 'MA' : 'MA') + val + ': -';
          const textWidth = ctx2.measureText(text).width;
          ctx2.fillText(text, left, baseLineY);
          left += textWidth;
        }
        left += space * this.dpr;
      }
    })

    // 港股延迟15分钟
    if (checkHKM(code) || checkAmerican(code)) {
      const {top, right} = this.availArea;
      const {
        sizeRatio,
        fontFamily,
        color,
        defaultText
      } = this.option.MainContext.tips;
      ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      ctx2.textAlign = 'right';
      ctx2.textBaseline = 'bottom';
      ctx2.fillText(defaultText, right, top);
    }
  }
}
